module.exports = __webpack_public_path__ + "img/18plus.715777b8.svg";